

if (!customElements.get('homepage-feature-product')) {
    customElements.define('homepage-feature-product',
        class ProductInfo extends HTMLElement {
            connectedCallback() {
                this.style.visibility = "visible"
                var dots = this.dataset.dots && this.dataset.dots == "true" ? true : false;
                var arrows = this.dataset.arrows && this.dataset.arrows == "false" ? false : true;
                // console.log($(this).find('.slick-products').children().length);
                if ($(this).find('.slick-products').children().length && $(this).find('.slick-products').children().length <= 4 && !dots) {
                    $(this).find('.slick-products').children().clone(true, true).appendTo($(this).find('.slick-products'));
                }

                let isAutoplay = this.dataset.autoplay == "true";
                let autoplaySpeed = parseInt(this.dataset.autoplay_speed) || 3;
                autoplaySpeed *= 1000;

                let mobileShow = parseInt(this.dataset.mobile_show) || 2;
                let breakpoint = [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: mobileShow,
                        },
                    },
                ];
                if (mobileShow == 1) {
                    $(this).find('.slick-products').addClass('has-padding-mobile');
                    breakpoint = [
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: mobileShow,
                                centerMode: true,
                                variableWidth: true
                            },
                        },
                    ];
                }
                $(this).find('.slick-products').slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    autoplay: isAutoplay,
                    autoplaySpeed: autoplaySpeed,
                    infinite: true,
                    arrows: arrows,
                    responsive: breakpoint,
                    dots: dots,

                });
            }
        }
    )
}

